<template>
    <div v-loading="loading">
      <div class="header">
        <el-button
          type="primary"
          @click="$router.push({ name: 'CategoriesAdd' })"
          >Qo'shish</el-button
        >
      </div>
      <el-table
        class="table-body"
        :data="tableData"
        border
        height="calc(100vh - 250px)"
      >
        <el-table-column type="index" label="T/r" />
        <el-table-column prop="initiative_category" label="Tashabbus kategoriyasi" />
        <el-table-column prop="title" label="Nomi" />
        <el-table-column align="center">
          <template #default="scope">
            <el-button
              size="small"
              type="danger"
              @click="deleteBudgetParam(scope.row.id)"
              >O'chirish
            </el-button>
            <el-button
              size="small"
              type="primary"
              @click="
                $router.push({
                  name: 'CategoriesEdit',
                  params: { id: scope.row.id },
                })
              "
              >Tahrirlash
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </template>
  
  <script>
  import { ElMessage, ElMessageBox, ElNotification } from "element-plus";
  export default {
    name: "CategoriesList",
    data() {
      return {
        loading: false,
        tableData: [],
        baseUrl: process.env.VUE_APP_BASE_API_URL + "/api/v2/info/file/",
      };
    },
    methods: {
      getBudgetParams() {
        this.loading = true;
        this.$http
          .get(`api/v1/product-categories?limit=10&offset=0`)
          .then(({ data }) => {
            this.tableData = data.product_categories;
          })
          .catch(({ response }) => {
            ElNotification.error({
              message:
                response.data.message ||
                "Ma'lumot yuklashda xatolik sodir bo'ldi!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      },
  
      deleteBudgetParam(id) {
        ElMessageBox.confirm("Parametrni o'chirasizmi?", "Diqqat!", {
          confirmButtonText: "Ha",
          cancelButtonText: "Bekor qilish",
          type: "warning",
        })
          .then(() => {
            this.loading = true;
            this.$http
              .delete(`api/v1/product-categories/${id}`)
              .then(() => {
                ElMessage({
                  type: "success",
                  message: "Muvaffaqqiyatli o'chirildi",
                });
                this.getBudgetParams();
              })
              .catch(() => {
                ElNotification({
                  type: "error",
                  title: "Xatolik",
                  message: "Iltimos, qayta urinib ko'ring",
                });
              })
              .finally(() => {
                this.loading = false;
              });
          })
          .catch(() => {
            ElMessage({
              type: "info",
              message: "O'chirish bekor qilindi",
            });
          });
      },
    },
    mounted() {
      this.getBudgetParams();
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
    gap: 10px;
  }
  .table-body {
    img {
      width: 80px;
    }
    
  }
  </style>
  